import { useTranslation } from 'react-i18next';

/**
 * PrivacyStep - First step of verification modal showing privacy notice
 * 
 * @param {Object} props
 * @param {Function} props.onContinue - Callback when user accepts and continues
 */
function PrivacyStep({ onContinue }) {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-gray-900">
        {t('verification.privacy-title', {
          defaultValue: 'Verificación de Identidad'
        })}
      </h3>
      
      <div className="amplify-card p-4 bg-blue-50 border border-blue-200 rounded-lg">
        <p className="text-sm text-gray-700 mb-3">
          {t('verification.privacy-notice', {
            defaultValue: 'Para verificar tu identidad, capturaremos imágenes de tu documento de identidad oficial y una selfie en vivo. Esta información se utilizará únicamente para fines de verificación de identidad.'
          })}
        </p>
        
        <p className="text-sm text-gray-700 mb-3">
          {t('verification.privacy-data-usage', {
            defaultValue: 'Tus datos biométricos serán:'
          })}
        </p>
        
        <ul className="text-sm text-gray-700 space-y-1 ml-4 mb-3">
          <li className="flex items-start">
            <span className="mr-2">•</span>
            <span>
              {t('verification.privacy-point-1', {
                defaultValue: 'Cifrados y almacenados de forma segura'
              })}
            </span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">•</span>
            <span>
              {t('verification.privacy-point-2', {
                defaultValue: 'Utilizados solo para verificación de identidad'
              })}
            </span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">•</span>
            <span>
              {t('verification.privacy-point-3', {
                defaultValue: 'No compartidos con terceros'
              })}
            </span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">•</span>
            <span>
              {t('verification.privacy-point-4', {
                defaultValue: 'Retenidos como parte del registro de auditoría del documento'
              })}
            </span>
          </li>
        </ul>
        
        <p className="text-xs text-gray-600">
          {t('verification.privacy-consent', {
            defaultValue: 'Al continuar, consientes la recopilación y procesamiento de tus datos biométricos para fines de verificación de identidad.'
          })}
        </p>
      </div>

      {/* Continue Button removed - now rendered in VerificationModal footer */}
    </div>
  );
}

export default PrivacyStep;
